import React from 'react'

const ImageIcon = () => {
  return (
    <svg
      width="1em"
      height="1em"
      fontSize="inherit"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="20"
        height="20"
        rx="5"
        stroke="#9D9D9D"
        strokeWidth="1.5"
      />
      <path
        d="M1.5 16.5L3.7592 14.8863C4.47521 14.3749 5.45603 14.456 6.07822 15.0782L7.15147 16.1515C7.6201 16.6201 8.3799 16.6201 8.84853 16.1515L13.8377 11.1623C14.496 10.504 15.5476 10.4563 16.2628 11.0523L21 15"
        stroke="#9D9D9D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        r="2"
        transform="matrix(-1 0 0 1 7 7)"
        stroke="#9D9D9D"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default ImageIcon
